import { render, staticRenderFns } from "./ParaMgr.vue?vue&type=template&id=cdf2335e&"
import script from "./ParaMgr.vue?vue&type=script&lang=js&"
export * from "./ParaMgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports